export { RolesPage } from './RolesPage'
export { rolesReducer, permissionsReducer } from './reducers'
export *  from './actions' 


// WEBPACK FOOTER //
// ./src/App/Admin/Roles/index.js